{% verbatim %}

<figure data-width="{{width}}" data-height="{{height}}" data-ratio="{{ratio}}" class="{{class}} res-image">
  <noscript data-tablet="{{tablet}}" data-mobile="{{mobile}}" data-retina="{{srcretina}}" data-src="{{src}}">
    <img src="{{src}}" class="{{class}}" />
  </noscript>
</figure>

{% endverbatim %}
